const SHORT_SUBJECT_TYPE = {
  'social': 'Social sciences',
  'engineering': 'Physics & Engineering',
  'math': 'Math & Statistics',
  'humanities': 'Humanities',
  'finance_text': 'Finance & Economics',
  'environmental': 'Environmental science',
  'literature': 'English & Literature',
  'it': 'Computer science & IT',
  'chemistry': 'Chemistry',
  'business': 'Business Studies',
}

const BONUS_TYPE = {
  // math: 0,
  finance: 5,
  finance_text: 5,
  engineering: 10,
  environmental: 5,
  it: 10,
  chemistry: 5,
  business: 10,
}

const LIMIT_TIME_V1 = 15;

const SUBJECT_TYPES = {
  math: 'math',
  finance: 'finance',
  finance_text: 'finance_text',
  engineering: 'engineering',
  social: 'social',
  humanities: 'humanities',
  environmental: 'environmental',
  literature: 'literature',
  it: 'it',
  chemistry: 'chemistry',
  business: 'business',
};

const SUBJECTS1 = [
  'Social sciences',
  'Physics & Engineering',
  'Math & Statistics',
  'Humanities',
  'Finance & Economics',
];

const SUBJECTS2 = [
  'Environmental science',
  'English & Literature',
  'Computer science & IT',
  'Chemistry',
  'Business Studies',
];

const SUB_SUBJECT = {
  'Social sciences': ['Law and International Law', 'Labor and Employee Relations', 'Political Science', 'HRM', 'Sociology', 'Psychology', 'Communication Studies', 'Governmental Studies', 'International Politics', 'International Relations'],
  'Physics & Engineering': ['Physics', 'Thermodynamics', 'Aerodynamics', 'Civil Engineering', 'Aerospace Engineering', 'Electrical Engineering', 'Mechanical Engineering', 'Network Engineering', 'Software Engineering'],
  'Math & Statistics': ['Calculus', 'Algebra', 'Maths', 'Analytics', 'Statistics', 'Game Theory', 'Geometry and Topology', 'Inferential Statistics', 'Logic', 'Number Theory'],
  'Humanities': ['Culture', 'Education', 'Healthcare and Nursing', 'History and Anthropology', 'Introduction to Visual Arts', 'Music', 'Nutrition', 'Philosophy', 'Public Health', 'Religion'],
  'Finance & Economics': ['Economics', 'Finance, Accounting and Banking', 'International Economics', 'Macroeconomics', 'Microeconomics', 'Political Economy', 'Sociology of Economy'],
  'Environmental science': ['Biology and Life Sciences', 'Ecology', 'Geography', 'Microbiology', 'Neuroscience', 'Physiology'],
  'English & Literature': ['Creative Writing', 'Academic Writing', 'Journalism', 'Literature', 'Linguistics'],
  'Computer science & IT': ['Data Science', 'Computer Science', 'Information Theory', 'IT Security', 'Artificial Intelligence', 'Programming', 'Web Development'],
  'Chemistry': ['Chemical Engineering', 'Chemistry'],
  'Business Studies': ['Business and Management', 'International Business', 'Marketing and PR', 'Organization Development', 'Project Management'],
}

export { SUBJECT_TYPES, SUBJECTS1, SUBJECTS2, SUB_SUBJECT, BONUS_TYPE, LIMIT_TIME_V1, SHORT_SUBJECT_TYPE };



// WEBPACK FOOTER //
// ./src/constants/subjectTypes.js